import 'css-chunksrc/client/pages/searchPage/searchResults/milestone/styles.scss';export default {
  "milestone": "_milestone_fr7b6_2",
  "icon": "_icon_fr7b6_15",
  "main": "_main_fr7b6_23",
  "header": "_header_fr7b6_27",
  "name": "_name_fr7b6_35",
  "zone": "_zone_fr7b6_40",
  "project": "_project_fr7b6_47",
  "projectIcon": "_projectIcon_fr7b6_55",
  "projectName": "_projectName_fr7b6_63",
  "match": "_match_fr7b6_69",
  "footer": "_footer_fr7b6_73"
};